import React, { useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/CloseRounded'
import Typography from '@material-ui/core/Typography'

import { useTranslation } from 'react-i18next'

import styles from './styles'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(styles)

const Header: React.FunctionComponent<any> = () => {
	const history = useHistory()
	const classes = useStyles()
	const goBack = useCallback(() => {
		history.goBack()
	}, [history])

	const { t } = useTranslation()

	return (
		<div className={classes.headerContainer}>
			<div className={classes.leftMenu}>
				<IconButton
					className={classes.closeButton}
					onClick={goBack}
				>
					<CloseIcon />
				</IconButton>
			</div>
			<div className={classes.middleMenu}>
				<Typography variant="h6" color="textPrimary">
					{t('Life at the office')}
				</Typography>
			</div>
			<div className={classes.rightMenu}></div>
		</div>
	)
}

export default Header
